<template>
  <div class="widgetInvoiceEstimateForm">
    <h3>Document Details</h3>

    <div class="columns price-columns-details-doctype">
      <div class="column">
        <b-field label="Document Type"
                 custom-class="is-size-6 has-text-weight-normal price-form"
        >
          <b-tabs type="is-toggle" v-model="docType" class="doctype">
            <b-tab-item label="Invoice" value='Invoice'></b-tab-item>
            <b-tab-item label="Estimate" value='Estimate'></b-tab-item>
          </b-tabs>
        </b-field>
      </div>
    </div>

    <template>
      <b-field
              grouped
              class="price-columns-details"
      >
        <b-field label="Submitted on"
                 class="price-column-submitted-on"
                 custom-class="is-size-6 has-text-weight-normal price-form"
        >
          <b-datepicker
                  v-model="submittedOn"
                  :date-formatter="customDateFormatter"
                  placeholder="mm/dd/yyyy"
                  icon="calendar-today"
                  expanded></b-datepicker>
        </b-field>
        <b-field label="Number"
                 :type="getFieldType('numberPrice')"
                 :message="getFieldError('numberPrice')"
                 class="price-column-number"
                 custom-class="is-size-6 has-text-weight-normal price-form"
        >
          <CustomInput
                  v-model="numberPrice"
                  inputmode="decimal"
                  :mask = "maskNumberPrice"
          />
        </b-field>
        <b-field label="License"
                 class="price-column-license"
                 custom-class="is-size-6 has-text-weight-normal price-form"
        >
          <b-input
                  v-model="license"
                  maxlength="50"
                  @blur="handleBlur('license', $event)"
          ></b-input>
        </b-field>
      </b-field>
    </template>

    <h3>Client Information</h3>
    <div class="columns price-columns-spec">
      <div class="column price-column-fullname">
        <b-field label="Full name"
                 custom-class="is-size-6 has-text-weight-normal price-form"
        >
          <b-input
            v-model="fullName"
            maxlength="100"
            @blur="handleBlur('fullName', $event)"
          ></b-input>
        </b-field>
      </div>
    </div>
    <div class="columns price-columns-spec">
      <div class="column">
        <b-field label="Company"
                 custom-class="is-size-6 has-text-weight-normal price-form"
        >
          <b-input
            v-model="company"
            maxlength="100"
            @blur="handleBlur('company', $event)"
          ></b-input>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Address"
                 custom-class="is-size-6 has-text-weight-normal price-form"
        >
          <b-input
            v-model="address"
            maxlength="100"
            @blur="handleBlur('address', $event)"
          ></b-input>
        </b-field>
      </div>
    </div>

    <h3>Project Specifications</h3>
    <div class="columns price-columns-spec">
      <div class="column is-two-thirds">
        <b-field label="Project name"
                 custom-class="is-size-6 has-text-weight-normal price-form"
        >
          <b-input
            v-model="projectName"
            maxlength="100"
            @blur="handleBlur('projectName', $event)"
          ></b-input>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Due date"
                 custom-class="is-size-6 has-text-weight-normal price-form"
        >
          <b-datepicker
            v-model="dueDate"
            :date-formatter="customDateFormatter"
            placeholder="mm/dd/yyyy"
            icon="calendar-today"
            locale="en-US"
            :icon-right="dueDate ? 'close-circle' : 'due-date-close'"
            position="is-bottom-left"
            icon-right-clickable
            trap-focus
            expanded></b-datepicker>
        </b-field>
      </div>
    </div>

    <div class="container">
      <PriceFormItem v-for="(item, index) in items"
        :key="index"
        :item="item"
        :index="index"
        :indexItem="indexItem"
        ref="priceFormItems"
        :calculateTotalPrice="calculateItemPrice"
        :deleteItem="deleteItem"
      >
      </PriceFormItem>
    </div>

    <div class="price-columns">
      <div class="column">
        <b-field
          class="add-btn"
        >
          <b-button @click="addItem" type="is-success is-outlined is-medium"
          class="add-item-btn">ADD ITEM</b-button>
        </b-field>
        <div class="column price-notes-desktop">
          <b-field label="Notes"
                   custom-class="is-size-6 has-text-weight-normal price-form">
            <b-input type="textarea"
                     v-model="notes"
                     maxlength="255"
                     placeholder=""
                     @blur="handleBlur('notes', $event)"
                     >
            </b-input>
          </b-field>
        </div>
      </div>
      <div class="column">
        <div class="block-input-tax">
          <b-field label="Subtotal"
                   horizontal
                   class="is-input"
                   custom-class="is-size-6 has-text-weight-normal price-form"
          >
            <span>{{ this.calculateSubTotal() }}</span>
          </b-field>
          <b-field label="Tax rate"
                   class="is-right"
                   custom-class="is-size-6 has-text-weight-normal price-form"
                   horizontal
          >
            <CustomInput
              v-model="taxRate"
              ref="inputTaxRate"
              :mask="maskPercentage"
              :placeholder="`0.00%`"
              inputmode="decimal"
              @getRawValue="getTaxRaw"
              :selectonfocus='`withoutPrefix`'
              style="width: 5.125rem; text-align: right;"
            />
          </b-field>
          <b-field
            label="Tax"
            horizontal
            class="is-input"
            custom-class="is-size-6 has-text-weight-normal price-form"
          >
            <span>{{ this.calculateTax() }}</span>
          </b-field>
          <b-field
            label="Adjustments"
            horizontal
            class="is-right"
            custom-class="is-size-6 has-text-weight-normal price-form"
          >
            <CustomInput v-model="adjustments"
                         ref="adjustments"
                         :mask="maksAdjustments"
                         :placeholder="`±$0.00`"
                         inputmode="decimal"
                         @getRawValue="getAdjustmentsRaw"
                         @blur="handleBlurAdjustments"
                         :selectonfocus='`withoutPrefix`'
                         style="width: 8.25rem; text-align: right;"
            />
          </b-field>
          <b-field label="Total"
                   horizontal
                   class="is-input"
                   custom-class="is-size-6 has-text-weight-normal price-form"
          >
            <b>{{ this.calculateTotal() }}</b>
          </b-field>
          <div class="price-notes-mobile">
            <b-field label="Notes">
              <b-input type="textarea"
                       v-model="notes"
                       maxlength="255"
                       placeholder="">
              </b-input>
            </b-field>
          </div>
          <div class="buttons" style="justify-content: flex-end;">
            <b-button @click="downloadPDF"
                      type="is-success is-medium is-right"
                      class="download-invoice"
                      :disabled="isButtonDownloadDisabled"
            >DOWNLOAD
            </b-button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapState } from 'vuex';
import getPdfInvoice from '@/api/price_widget';
import CustomInput from '@/components/CustomInput.vue';
import PriceFormItem from './InvoiceEstimateFormItem.vue';

export default {
  name: 'InvoiceEstimateForm',
  components: {
    PriceFormItem,
    CustomInput,
  },
  data() {
    return {
      srcDueDate: null,
      maskNumberPrice: {
        blocks: [20],
        numericOnly: true,
      },
      maskPercentage: {
        numeralIntegerScale: 3,
        numeral: true,
        numeralDecimalMark: '.',
        delimiter: '',
        numeralPositiveOnly: true,
        numeralDecimalScale: 2,
        prefix: '%',
        tailPrefix: true,
      },
      maksAdjustments: {
        numeral: true,
        numeralThousandsGroupStyle: 'thousand',
        numeralDecimalScale: 2,
        numeralIntegerScale: 6,
        numeralPositiveOnly: false,
        signBeforePrefix: true,
        prefix: '$',
        // stripLeadingZeroes: false,
        noImmediatePrefix: true,
        rawValueTrimPrefix: true,
      },
      indexItem: null,
      isButtonDownloadDisabled: false,
      numberPrice: '',
      license: '',
      submittedOn: new Date(),
      docType: 0,
      fullName: '',
      company: '',
      address: '',
      projectName: '',
      items: [
        {
          description: '',
          quantity: 1,
          unitPrice: '$0.00',
        },
      ],
      notes: '',
      taxRate: '0%',
      tax: '0%',
      subTotal: 0,
      adjustments: '$0.00',
      adjustmentsRaw: 0,
      total: 0,
      value: '',
      errors: {},
      clearButtonDueDate: null,
    };
  },
  props: {
    pageId: {
      type: Number,
      default: null,
    },
  },
  mounted() {
    this.isButtonDownloadDisabled = false;
    const classClearBtnDueDate = 'span.icon.is-right.is-clickable > i.mdi.mdi-due-date-close';
    if (document.querySelector(classClearBtnDueDate)) {
      this.clearButtonDueDate = document.querySelector(classClearBtnDueDate).parentNode;
      if (this.clearButtonDueDate) {
        this.clearButtonDueDate.addEventListener('click', this.clearDueDate);
      }
    }
  },
  beforeDestroy() {
    if (this.clearButtonDueDate) {
      this.clearButtonDueDate.removeEventListener('click', this.clearDueDate);
    }
  },
  methods: {
    clearDueDate(e) {
      e.stopPropagation();
      this.dueDate = null;
    },
    getTaxRaw(value) {
      this.taxRaw = value;
    },
    handleBlurAdjustments() {
      if (this.adjustments === '-$') {
        this.adjustments = '';
      }
    },
    getAdjustmentsRaw(value) {
      this.adjustmentsRaw = value;
    },
    addItem() {
      this.indexItem += 1;
      this.items.push({
        description: '',
        quantity: 1,
        unitPrice: '$0.00',
      });
      this.$nextTick(() => {
        this.$refs.priceFormItems[this.$refs.priceFormItems.length - 1].setFocus();
      });
    },
    deleteItem(index) {
      this.indexItem -= 1;
      if (index === 0 && this.indexItem === -1) {
        this.items.splice(index, 1);
        this.addItem();
      } else {
        this.items.splice(index, 1);
      }
    },
    itemHasChanges(item) {
      return item.description || item.quantity !== 1 || item.unitPrice !== 0;
    },
    currency(amount, roundDigits) {
      if (typeof amount === 'undefined' || amount === null || amount === '') {
        return 0;
      }
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: roundDigits,
        maximumFractionDigits: roundDigits,
      });
      return formatter.format(amount);
    },
    convertPriceToNumber(priceString) {
      if (typeof priceString !== 'string') {
        return 0;
      }
      const cleanedString = priceString.replace(/[^0-9.+-]/g, '');
      let numericValue = parseFloat(cleanedString);
      if (Number.isNaN(numericValue)) {
        numericValue = 0;
      }
      return Math.floor(numericValue * 100) / 100;
    },
    calculateItemPrice(item) {
      const numericString = this.convertPriceToNumber(item.unitPrice);
      const quantityString = this.convertPriceToNumber(`${item.quantity}`);
      let ret = quantityString * numericString;
      if (Number.isNaN(ret)) {
        ret = 0;
      }
      return this.currency(Math.abs(ret), 2);
    },
    calculateSubTotal() {
      let ret = this.items.reduce((total, item) => {
        const unitPrice = this.convertPriceToNumber(item.unitPrice);
        const quantityString = this.convertPriceToNumber(`${item.quantity}`);
        return total + (quantityString * unitPrice);
      }, 0);
      if (Number.isNaN(ret)) {
        ret = 0;
      }
      this.subTotal = ret;
      return this.currency(ret, 2);
    },
    calculateTotal() {
      let ret = this.subTotal + this.tax + this.convertPriceToNumber(this.adjustmentsRaw);
      if (Number.isNaN(ret)) {
        ret = 0;
      }
      this.total = ret;
      return this.currency(ret, 2);
    },
    calculateTax() {
      let ret = (this.taxRaw * this.subTotal) / 100;
      if (Number.isNaN(ret)) {
        ret = 0;
      }
      this.tax = ret;
      return this.currency(ret, 2);
    },
    downloadPDF() {
      this.isButtonDownloadDisabled = true;
      this.errors = {};
      const queryParams = {
        userId: this.userId,
        docType: this.docType,
        fullName: this.fullName,
        company: this.company,
        address: this.address,
        projectName: this.projectName,
        dueDate: this.dateToString(this.dueDate),
        notes: this.notes,
        taxRate: this.taxRate,
        adjustments: this.adjustments,
        submittedOn: this.dateToString(this.submittedOn),
        numberPrice: this.numberPrice,
        license: this.license,
        items: JSON.stringify(this.items),
      };

      getPdfInvoice(this.pageId, queryParams).then((response) => {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const file = window.URL.createObjectURL(blob);
        window.open(file);
        this.isButtonDownloadDisabled = false;
      })
        .catch((error) => {
          if (error.response.data.type === 'application/json' && error.response.status !== 500) {
            const fReader = new FileReader();
            fReader.readAsText(error.response.data);
            fReader.addEventListener('loadend', () => {
              const data = JSON.parse(fReader.result);
              this.errors = data.errors;
              if (data.errors) {
                const errorMessageString = Object.values(data.errors).join('\n');
                this.$buefy.toast.open({ message: errorMessageString, type: 'is-danger' });
              }
            });
          } else {
            this.$buefy.toast.open({ message: 'An unexpected error occurred, please contact support@enhancify.com', type: 'is-danger' });
          }
        })
        .finally(() => {
          this.isButtonDownloadDisabled = false;
        });
    },
    getValidationMessage(field, maxLength) {
      if (this[field].trim().length === 0) {
        return 'This field is required.';
      }
      if (this[field].length > maxLength) {
        return `Maximum ${maxLength} characters allowed.`;
      }
      return null;
    },
    customDateFormatter(date) {
      const options = { month: '2-digit', day: '2-digit', year: 'numeric' };
      return new Intl.DateTimeFormat('en-US', options).format(date);
    },
    dateToString(date) {
      const options = { month: '2-digit', day: '2-digit', year: 'numeric' };
      return new Intl.DateTimeFormat('en-US', options).format(date);
    },
    getFieldType(fieldName) {
      return this.errors[`[${fieldName}]`] ? 'is-danger' : null;
    },
    getFieldError(fieldName) {
      return this.errors[`[${fieldName}]`] ? this.errors[`[${fieldName}]`] : '';
    },
    resetForm() {
      this.numberPrice = '';
      this.license = '';
      this.submittedOn = new Date();
      this.docType = 0;
      this.fullName = '';
      this.company = '';
      this.address = '';
      this.projectName = '';
      this.srcDueDate = null;
      this.items = [
        {
          description: '',
          quantity: 1,
          unitPrice: '$0.00',
        },
      ];
      this.notes = '';
      this.tax = '0';
      this.taxRate = '0%';
      this.subTotal = 0;
      this.adjustments = '$0.00';
      this.adjustmentsRaw = 0;
      this.total = 0;
      this.value = '';
      this.errors = {};
    },
    handleBlur(propertyName, event) {
      this[propertyName] = event.target.value.trim().replace(/ {2,}/g, ' ');
    },
  },
  computed: {
    ...mapState('contractor', { contractorId: (state) => state.id }),
    ...mapState('user', { userId: (state) => state.id }),
    dueDate: {
      get() {
        return this.srcDueDate;
      },
      set(value) {
        this.srcDueDate = value || null;
      },
    },
  },
  watch: {
    shouldEnableDownloadButton(newValue) {
      this.isButtonDownloadDisabled = !newValue;
    },
  },
};
</script>

<style lang="stylus">

//@import "~@/assets/style/variables.styl";

.widgetInvoiceEstimate

  .input, .textarea
    border 1px solid #8fa7b3
    box-shadow none
    -webkit-box-shadow none

  .textarea:active, .textarea:focus
    border-color #3273dc
    box-shadow none

  .is-horizontal
    display flex
    justify-content space-between

  .widgetInvoiceEstimateForm
    max-width 860px
    padding-top 20px
    .has-text-weight-normal.price-form
      color #969ea2

    .input
      min-height 3rem
      box-shadow none

    .tabs.is-toggle li a
      min-height 3rem

    .doctype
      display flex

    nav
      width 100%
      li
        flex 1

    .control.has-icons-right .icon.is-right
      height 3rem
      color #68ba62

    .control.has-icons-left .icon.is-left
      height 3rem
      color #68ba62
    .is-success.is-outlined
      background-color transparent
      border-color #68BA62
      color #68BA62
    .is-success.is-outlined:hover
      background-color #17b548
      border-color #17b548
      color #ffffff

    .price-columns-details
    .price-column-submitted-on
    .price-column-number
      padding-bottom 10px
    .price-columns
      .column
        .block-input-tax
          .buttons
            button.button
              height 48px;

    // DESKTOP with screen width up 1024
    @media print, screen and (min-width: 1024px)

      .price-column-submitted-on
        width calc(25% - 5px)
        padding-right 10px

      .price-column-number
        width calc(25% - 5px)
        padding-right 10px

      .price-column-license
        width calc(50% - 5px)
        padding-right 10px

    // DESKTOP with screen width up 769 to 1023
    @media print, screen and (min-width: 769px) and (max-width: 1023px)

      .field.is-grouped .field:not(:last-child)
        margin-right 0

      .price-columns-details
        display flex
        flex-direction row
        flex-wrap wrap
        justify-content space-between
        .input-text-right
          text-align right
          .input
            text-align right

      .price-column-submitted-on
        width 33%

      .price-column-number
        width 66%
        padding-left 20px

      .price-column-license
        width 100%

    // DESKTOP with screen width up 769
    @media print, screen and (min-width: 769px)

      width calc(100% - 32px)

      .doctype
        width 50%

      .price-columns
        button
          font-size 19px
        .column:first-child
          padding-left 0
          padding-top 0

        .column:nth-child(2)
          padding-right 0

      .price-column-fullname
        padding-bottom 0

      .price-columns-details-doctype
        padding-bottom 10px

      .block-input-tax
        padding-right 0
        padding-left 20px
        margin-left auto
        max-width 300px

      .block-input-tax
        text-wrap nowrap
        white-space nowrap

        .field.is-horizontal
          .field-body
            text-align right

      .field.is-horizontal
        display flex
        justify-content space-between
        flex-wrap nowrap
        flex-direction row
        align-items center
        margin-bottom -5px

        .field-body
          min-width 50%
          flex-basis min-content

      .is-right
        text-align right

      .field.is-input
        text-align right
        padding-top 20px
        padding-bottom 20px
        padding-right 10px

        .field-label
          text-align left
          margin-bottom 0

      .buttons
        margin-top 15px

      .item-row
        display flex
        align-items center
        gap 20px

      .b-field-grouped > .b-input
        border-right 1px solid #ccc
        margin-right -1px
        padding-right 0.5rem

      .is-near
        display flex
        padding-bottom 10px

      .is-near div.clm:first-child
        input
          border-bottom-left-radius 4px
          border-top-left-radius 4px
          border-right none

      .is-near div.clm
        input
          border-radius 0
          border-right none

      .is-near div.clm div.last input
        border-bottom-right-radius 4px
        border-top-right-radius 4px
        border-right 1px solid #dbdbdb

      .widgetInvoiceEstimateForm .label
        font-weight 400

      .columns .buttons
        flex-wrap initial

        nav
          width 100%
          li
            flex 1

      .price-columns
        display flex
        .add-btn
          padding-top 10px
          button.button
            height 48px

        .column:nth-child(2)
          padding-top 0
          padding-right 0

      .price-notes-desktop
        display flex
        padding-left 0
        .field:first-child
          width 100%
          padding-top 30px
        .label
          font-weight 400

      .price-notes-mobile
        display none

    @media print, screen and (max-width: 768px) // MOBILE

      .price-notes-desktop
        display none !important

      .price-notes-mobile
        display block
        padding-top 15px
        .label
          font-weight 400

      .doctype
        width 100%

      .columns
        padding 0
        .column
          padding 0

      .price-items
        border-radius 5px

      .tab-content
        padding-bottom 0

      .container
        padding-bottom 10px
        padding-top 10px
        margin-left -10px
        margin-right -10px

      .price-columns-details-doctype
        padding-left 13px
        padding-right 10px
        padding-top 20px
        .column
          padding-bottom 10px

      .price-columns-details
        display flex
        flex-direction row
        flex-wrap wrap
        .input-text-right
          text-align right
          .input
            text-align right

      .price-column-submitted-on
        width 100%

      .price-column-number
        width 100%

      .price-column-license
        width 100%

      .price-columns-spec.columns
        padding-top 10px
        padding-bottom 10px
        margin 0
        .field
          padding-bottom 0
        .price-column-fullname
          margin-bottom -20px

      .column.price-column-one
        padding 10px
        margin -10px
        padding-bottom 0

      .price-columns
        padding-top 10px
        .column
          padding 0
          button.button
            height 48px
        .button
          @media(max-width 499px)
            width 100%

      .block-input-tax
        padding-top 20px
        .field
          align-items center
        .is-input
          padding-right 10px
        .field-label
          margin-bottom 0
        .buttons
          justify-content flex-end
          display flex
          flex-direction column
          align-content space-between
          .button
            @media(max-width 499px)
              width 100%
            margin-right 0
</style>
